import { useAsyncEffect, useRequest } from 'ahooks';
import { useEffect, useState } from 'react';
import { queryPortalsService } from '../PortalMgr/services';
import { IMenuProps, IPortalProps } from '../PortalMgr/typing';
import {
  queryMenusByRoleIdService,
  queryPortalsByRoleIdService,
  queryRolesService,
} from './services';
import { IRoleProps } from './typing';

export default function PortalMgrModel() {
  const [selectedRole, setSelectedRole] = useState<IRoleProps | null>(null);
  const [currentRolePortals, setcurrentRolePortals] = useState<IPortalProps[]>(
    [],
  );
  const [currentRoleMenus, setcurrentRoleMenus] = useState<IMenuProps[]>([]);

  const { data: roleList, run: queryRoleList } = useRequest(
    () => queryRolesService(),
    {
      manual: true,
    },
  );

  const { data: portalList, run: queryPortalList } = useRequest(
    () => queryPortalsService(),
    {
      manual: true,
    },
  );

  const quertCurrentRoleMenus = async () => {
    const menusData = await queryMenusByRoleIdService(selectedRole!.roleId);
    setcurrentRoleMenus(menusData);
  };

  const quertCurrentRolePortals = async () => {
    const portalsData = await queryPortalsByRoleIdService(selectedRole!.roleId);
    setcurrentRolePortals(portalsData);
  };

  useEffect(() => {
    if (roleList?.length) {
      setSelectedRole(roleList[0]);
      queryPortalList();
    }
  }, [roleList]);

  useAsyncEffect(async () => {
    if (selectedRole?.roleId) {
      quertCurrentRolePortals();
      quertCurrentRoleMenus();
    }
  }, [selectedRole]);

  return {
    roleList,
    queryRoleList,
    portalList,
    selectedRole,
    setSelectedRole,
    currentRolePortals,
    quertCurrentRolePortals,
    currentRoleMenus,
    quertCurrentRoleMenus,
  };
}
